import { render } from "./CahpsSurveyRecipient.vue?vue&type=template&id=2128dae4&class=mt-2"
import script from "./CahpsSurveyRecipient.ts?vue&type=script&lang=js&external"
export * from "./CahpsSurveyRecipient.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__